import { useTranslation } from "react-i18next";

export const useTranslateData = () => {
  const { t } = useTranslation();

  return [
    [
      { id: "os", key: t("anonymityCheck.userInfo.OS"), value: "-" },
      {
        id: "browser",
        key: t("anonymityCheck.userInfo.browser"),
        value: "-",
      },
    ],
    [
      {
        id: "timeZone",
        key: t("anonymityCheck.userInfo.timeZone"),
        value: "-",
      },
      {
        id: "time",
        key: t("anonymityCheck.userInfo.timeIP"),
        value: "-",
      },
      {
        id: "systemTime",
        key: t("anonymityCheck.userInfo.timeSystem"),
        value: "-",
      },
    ],
    [
      {
        id: "userAgent",
        key: t("anonymityCheck.userInfo.userAgent"),
        value: "-",
      },
      {
        id: "userAgentJs",
        key: t("anonymityCheck.userInfo.userAgentJS"),
        value: "-",
        labelStatus: false,
      },
    ],
    [
      {
        id: "language",
        key: t("anonymityCheck.userInfo.language"),
        value: "-",
      },
      {
        id: "languageJs",
        key: t("anonymityCheck.userInfo.languageJS"),
        value: "-",
      },
      {
        id: "screen",
        key: t("anonymityCheck.userInfo.screen"),
        value: "-",
      },
    ],
  ];
};
